import React from "react";
import "moment-timezone";
import 'react-slidedown/lib/slidedown.css'
import Tooltip from "@material-ui/core/Tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faExclamationTriangle, faHourglassHalf, faSpinner, faTimesCircle} from "@fortawesome/free-solid-svg-icons";

class EstadoParticipacaoModulo extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let icons_style = {marginRight: "5px"};
    let icons = {
      OPT: <FontAwesomeIcon icon={faCheckCircle} color={"#aab3c4"} style={icons_style}/>,
      OK: <FontAwesomeIcon icon={faCheckCircle} color={"#16924a"} style={icons_style}/>,
      PEND: <FontAwesomeIcon icon={faHourglassHalf} color={"#6a93a2"} style={icons_style}/>,
      PEND_FEEDBACK: <FontAwesomeIcon icon={faHourglassHalf} color={"#6a93a2"} style={icons_style}/>,
      PROG: <FontAwesomeIcon icon={faSpinner} color={"#1babbf"} style={icons_style}/>,
      NOK: <FontAwesomeIcon icon={faExclamationTriangle} color={"#fd9729"} style={icons_style}/>,
      REP_FEEDBACK: <FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"} style={icons_style}/>,
      REP_FALTOU: <FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"} style={icons_style}/>,
      REP: <FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"} style={icons_style}/>
    };

    let {estado} = this.props;
    if (!estado || !estado.resultado) return null;
    return this.props.detailed ? <span>{icons[estado.resultado.codigo]} {estado.resultado.designacao}</span> : <Tooltip
      title={estado.resultado.designacao}
      placement={this.props.tooltipPlacement || "right"}
    ><span>{icons[estado.resultado.codigo] || estado.resultado.designacao}</span></Tooltip>;
  }
}

export default EstadoParticipacaoModulo;
